import type { ExploreContentItemContentOneOfAuthorBasicInfo } from './exploreContentItemContentOneOfAuthorBasicInfo';
import type { ExploreContentItemContentOneOfAuthorSocial } from './exploreContentItemContentOneOfAuthorSocial';

/**
 * 트윗 작성자 정보
 */
export type ExploreContentItemContentOneOfAuthor = {
  /** 사용자 기본 정보 */
  basicInfo: ExploreContentItemContentOneOfAuthorBasicInfo;
  /** 소셜 관계 정보 */
  social?: ExploreContentItemContentOneOfAuthorSocial;
};
